"use client";

import React from "react";
import { motion, AnimatePresence } from "framer-motion";

interface PaginationInfoProps {
    currentSlide: number;
    title: string;
}

export function PaginationInfo({
    currentSlide,
    title,
}: PaginationInfoProps) {
    return (
        <div className="h-[148px]  md:h-auto flex flex-col md:flex-row justify-center md:justify-start md:items-center gap-[4px] md:gap-[24px]">
            <motion.span
                key={currentSlide}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.3 }}
                className="text-3xl-bold text-[#0E8668]"
            >
                {String(currentSlide + 1).padStart(2, "0")}
            </motion.span>

            <div className="hidden md:block border-r h-[60px] border-black/10" />

            <AnimatePresence mode="wait">
                <motion.p
                    key={currentSlide + "-title"}
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.3 }}
                    className="text-m-regular xl:max-w-[249px] text-text-dark line-clamp-2"
                >
                    {title}
                </motion.p>
            </AnimatePresence>
        </div>
    );
}
